// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-icon {
  font-size: 10rem;
}

.button-icon {
  width: 1.5rem;
}

.button-icon-smaller {
  width: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main/pages/dynamic-modal/dynamic-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":[".main-icon {\r\n  font-size: 10rem;\r\n}\r\n\r\n.button-icon {\r\n  width: 1.5rem;\r\n}\r\n\r\n.button-icon-smaller {\r\n  width: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
